export const hideEmail = email => {
  const [localPart, domain] = email.split('@');
  return `${localPart.slice(0, 2)}****@${domain}`;
};
